import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FoliarApplicationAdvice, FoliarFormData } from '../../../recommendations';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export function usePostAdviceFoliar() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<FoliarApplicationAdvice, Error, FoliarFormData>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post('/advices/foliar-application/create', payload, {
					params: { forBinding },
				});
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar a recomendação de foliares');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['foliar'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao criar recomendação de foliares:',
				getApiErrorMessage(error, 'Erro ao criar a recomendação de foliares')
			);
		},
	});
}
